export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtLakdruh';
export const NAME = 'DruhLaku';
